function fadeIn(element) {
  var op = 0.01;
  var timer = setInterval(function () {
    if (op >= 1) {
      clearInterval(timer);
    }
    element.style.opacity = op;
    op += op * 0.1;
  }, 75);
}

export default fadeIn;
